import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Col, FormGroup, ControlLabel, HelpBlock } from 'react-bootstrap';
import WidgetMultiselect from 'react-widgets/lib/Multiselect';

const MultiSelect = ({ name, label, horizontal, t, input: { onChange, value }, help, meta: { touched, error, warning }, valueField = 'value', textField = 'label', required, options, ...props }) => {

	const validationState = touched && (error && "error") || (warning && "warning") || null;

	const formControl = <WidgetMultiselect
		name={name}
		data={options}
		valueField={valueField}
		textField={textField}
		onChange={onChange}
		value={value}
		placeholder={t('Common_SelectMultiple')}
		{...props}
	/>;
	const errorBlock = touched && (error || warning) && <HelpBlock>{error || warning}</HelpBlock>;
	const helpBlock = help && <HelpBlock>{help}</HelpBlock>;
	const labelHint = required && <em className='required_s'>*</em>;

	if (horizontal) {
		return (
			<FormGroup validationState={validationState}>
				<Col componentClass={ControlLabel} sm={2}>
					{label}{labelHint}
				</Col>
				<Col sm={10}>
					{formControl}
					{errorBlock}
					{helpBlock}
				</Col>
			</FormGroup>);
	}

	return (
		<FormGroup validationState={validationState}>
			<ControlLabel>{label}{labelHint}</ControlLabel>
			{formControl}
			{errorBlock}
			{helpBlock}
		</FormGroup>
	);
};

export default withTranslation()(MultiSelect);